import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { useLogin } from "../../hooks/useLogin";

const Login = () => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [codigo, setCodigo] = useState("");
  const { login, confirmar2fa, cancelar2fa, desafio, success, loading, error } = useLogin();
  const navigate = useNavigate();

  useEffect(() => {
    if (success) {
      navigate("/");
    }
  }, [success, navigate]);

  const handleLogin = () => {
    login({ email, senha });
  };

  /**
   * SEGUNDA ETAPA (só aparece para conta com 2FA ativo). A senha já foi aceita, mas o login
   * ainda não terminou — o token só existe depois daqui.
   */
  if (desafio) {
    return (
      <div className="login-container">
        <img src="imgs/reino_header_logo.svg" alt="Reinoplay Logo" className="login-logo" />
        <form
          className="login-form-vertical"
          onSubmit={(e) => {
            e.preventDefault();
            confirmar2fa(codigo);
          }}
        >
          <p style={{ color: "#bbb", fontSize: 14, textAlign: "center", margin: "0 0 4px" }}>
            Digite o código do seu app autenticador.
          </p>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            autoFocus
            placeholder="000000"
            className="login-input"
            style={{ textAlign: "center", letterSpacing: 8, fontSize: 22 }}
            value={codigo}
            onChange={(e) => setCodigo(e.target.value.trim())}
          />
          {error && <p className="login-error-message">{error}</p>}
          <button className="login-button" type="submit" disabled={loading}>
            {loading ? "Verificando..." : "Confirmar"}
          </button>
          <p style={{ color: "#777", fontSize: 12, textAlign: "center", margin: "6px 0 0" }}>
            Perdeu o celular? Use um dos seus códigos de backup aqui mesmo.
          </p>
          <button type="button" className="login-forgot" onClick={cancelar2fa}>
            Voltar
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="login-container">
      <img src="imgs/reino_header_logo.svg" alt="Reinoplay Logo" className="login-logo" />
      <form className="login-form-vertical" onSubmit={e => { e.preventDefault(); handleLogin(); }}>
        <input
          type="text"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Senha"
          className="login-input"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        {error && <p className="login-error-message">{error}</p>}
        <button
          className="login-button"
          type="submit"
          disabled={loading}
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>
        {/* Botão "Criar conta" ocultado: contas são criadas pela venda (Greenn → n8n),
            ninguém deve se cadastrar sozinho pelo app. Para reativar, restaurar o <button>. */}
        <button
          type="button"
          className="login-forgot"
          onClick={() => navigate("/esqueci-senha")}
        >
          Esqueci a senha
        </button>
      </form>
    </div>
  );
};

export default Login;
